

















import {
  computed,
  defineComponent,
  useContext,
  useStore,
} from '@nuxtjs/composition-api'
import { IHolidayTheme } from '@/contracts/Settings'
import MediatorItem from '@/components/MediatorItem.vue'

// Кеш загрузчиков: один экземпляр на тип компонента за всё время жизни модуля.
// Гарантирует стабильность ссылки на функцию между ре-рендерами — Vue не будет
// пересоздавать async-компонент при каждом обновлении parsedComponents.
const componentLoaderCache = new Map<string, () => Promise<any>>()

const loadComponent = (type: string) => {
  if (!componentLoaderCache.has(type)) {
    const normalized = type.replace(/section/i, 'Section')
    componentLoaderCache.set(type, () =>
      import(`@/views/${normalized}`).catch((e) => {
        console.error(`Component ${type} not found`)
        return { template: `<div>Component ${type} not found</div>` }
      })
    )
  }
  return componentLoaderCache.get(type)!
}

export default defineComponent({
  name: 'Mediator',
  components: { MediatorItem },
  props: {
    components: {
      type: Array,
      default: () => [],
    },
    hideContent: {
      type: Boolean,
      default: false,
    },
    hideDelimiters: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const context = useContext()
    const store = useStore()

    const isDebugTemplatesShown = computed(
      () => context.$config.IS_DEBUG_TEMPLATES_SHOWN === 'true'
    )

    const holidayTheme = computed<IHolidayTheme>(
      () => store.getters['settings/holidayTheme']
    )

    const parsedComponents = computed(() => {
      if (!props.components) return []

      const result = []

      for (const component of props.components) {
        const type = component.type || 'dummy'

        if (type === 'dummy' && !isDebugTemplatesShown.value) {
          continue // пропускаем dummy-секции в обычном режиме
        }

        const forceEager = ['sectionCustom'].includes(type)

        result.push({
          ...component,
          type,
          compFunc: loadComponent(type),
          forceEager,
        })
      }

      if (props.hideContent) {
        const iframeComponents = result.filter(
          (component) => component.name === 'sectionIframe'
        )
        if (iframeComponents.length) return iframeComponents
      }

      return result
    })

    return {
      parsedComponents,
      isDebugTemplatesShown,
      holidayTheme,
    }
  },
})
